module.exports = __webpack_public_path__ + "sansg/img/18.a38736e0.png";